import * as R from 'ramda';

class CodeTables {
  static codes = {};

  get(table) {
    if (R.has(`code_${table}`, CodeTables.codes)) {
      return CodeTables.codes[`code_${table}`];
    } else {
      return [];
    }
  }

  setup(codes) {
    CodeTables.codes = codes;
    CodeTables.codes.code_csi_hierarchy = this.hierarchy(codes.code_csi);
    CodeTables.codes.code_companytype_hierarchy = this.hierarchy(codes.code_companytype);
  }

  hierarchy(flat) {
    let roots = [];
    let all = {};
    flat.forEach(item => all[item.code] = { label: `${item.code} - ${item.name}`, value: item.code, parent: item.parent, key: item.code });
    Object.keys(all).forEach(code => {
      let item = all[code];
      if (item.parent === null) {
        roots.push(item)
      } else if (item.parent in all) {
        let p = all[item.parent];
        if (!('children' in p)) {
          p.children = [];
        }
        p.children.push(item);
      }
    });
    this.sortTree(roots);
    return roots;
  }

  sortTree(tree) {
    tree.sort((x1, x2) => {
      if (x1.label < x2.label) return -1;
      if (x1.label > x2.label) return 1;
      return 0;
    });
    tree.forEach(child => {
      if ('children' in child) {
        this.sortTree(child.children);
      }
    });
  }

}

export const codeTables = new CodeTables();



// WEBPACK FOOTER //
// ./src/codes.js